import React, { useEffect, useState } from "react";
import { CiBookmarkPlus, CiBookmarkCheck } from "react-icons/ci";
import { getDictionaryEntry } from "../../data/flashcardsRepo";
import { FaPlay } from "react-icons/fa";
import StoryFlashcardPractice from "./StoryFlashcardPractice";
import "./StoryKeywords.css";

export default function StoryKeywords({ story, onAddFlashcard, addedWords = [], savedWords = [],   onWordClick }) {
  const [keywordsData, setKeywordsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tokensData, setTokensData] = useState(null);

  async function getWordEntry(lemma, pos) {
    return getDictionaryEntry({ lemma, pos });
  }
  

  useEffect(() => {
    let cancelled = false;
    setKeywordsData([]);
    setLoading(true);
  
    async function loadKeywords() {
      try {
        const results = await Promise.all(
          story.keywords.map(async (kw) => {
            const data = await getWordEntry(kw.lemma, kw.pos);
            return data ? { ...data, lemma: kw.lemma, pos: kw.pos } : null;
          })
        );
    
        if (!cancelled) {
          setKeywordsData(results.filter(Boolean));
          setLoading(false);
        }
      } catch (e) {
        console.error("Error loading keywords:", e);
        if (!cancelled) {
          setKeywordsData([]);
          setLoading(false);
        }
      }
    }
    
  
    loadKeywords();
    return () => {
      cancelled = true;
    };
  }, [story]);

  useEffect(() => {
    let cancelled = false;
  
    async function loadTokens() {
      setTokensData(null);
      try {
        // story.audio looks like "/stories/bio-elon-musk_de/audio.mp3"
        const folder = story.audio.split("/").slice(0, 3).join("/"); // "/stories/bio-elon-musk_de"
        const res = await fetch(`${folder}/tokens.json`);
        if (!res.ok) return;
        const json = await res.json();
        if (!cancelled) setTokensData(json);
      } catch {
        // ignore -> fallback will be used
      }
    }
  
    if (story?.audio) loadTokens();
    return () => { cancelled = true; };
  }, [story]);
  
  

  if (loading) return <p className="flashcard-loading">Carregando flashcards...</p>;

  const practiceCards = keywordsData.map((word, i) => {
    let matchingSentenceObj = null;

    // 1) best: lemma+pos match via tokens.json
    if (tokensData?.sentences) {
      const targetLemma = word.lemma.toLowerCase();
      const targetPos = word.pos.toLowerCase();
    
      const sentId = Object.entries(tokensData.sentences).find(([id, toks]) =>
        toks.some(t =>
          String(t.lemma).toLowerCase() === targetLemma &&
          String(t.pos).toLowerCase() === targetPos
        )
      )?.[0];
    
      if (sentId) {
        matchingSentenceObj = story.sentences.find(
          s => String(s.id) === String(sentId)
        ) || null;
      }
    }
    
    // 2) fallback: old surface match
    if (!matchingSentenceObj) {
      matchingSentenceObj =
        story.sentences.find(s =>
          s.text.toLowerCase().includes(word.word.toLowerCase())
        ) || null;
    }
    
    const matchingSentence = matchingSentenceObj?.text || "";
    const matchingSentenceTranslation = matchingSentenceObj?.translation || "";
  
    return {
      id: `story-${story.id}-${i}`,
      word: word.word,
      article: word.article || null,
      pos: word.pos,
      translations_pt: word.translations_pt,
      sentence: matchingSentence,      // IMPORTANT: FlashcardItem expects THIS
      sentenceTranslation: matchingSentenceTranslation,
      plural: word.plural || null,
      audio: word.audio || null,
  
      // FlashcardItem expects `status`
      status: "new",                   // safe default, ignored in trainingMode
    };
  });
  

  return (
    <div className="keywords-container">
      {/* Practice header */}

      <div className="keywords-practice-section">
        <StoryFlashcardPractice
          cards={practiceCards}
          onClose={() => {}}
        />
      </div>

      {/* Existing keyword list
      <div className="keywords-list">
        {keywordsData.map((word, i) => {
          const wordKey = word.word.toLowerCase();

          const isSaved =
            addedWords.includes(wordKey) ||
            savedWords?.includes(wordKey) ||
            (word.lemma && savedWords?.includes(word.lemma.toLowerCase()));

          const matchingSentence = story.sentences.find((s) =>
            s.text.toLowerCase().includes(word.word.toLowerCase())
          );

          return (
            <div
              key={i}
              className={`keyword-card ${isSaved ? "saved" : ""}`}
              onClick={() => onWordClick && onWordClick(word)}
            >
              <div className="keyword-info">
                <div className="keyword-top">
                  <span className="keyword-word">
                    {word.article ? `${word.article} ` : ""}
                    {word.word}
                  </span>
                  <span className="keyword-pos">{word.pos}</span>
                </div>

                <p className="keyword-translation">
                  {Array.isArray(word.translations_pt)
                    ? word.translations_pt.join(", ")
                    : word.translations_pt}
                </p>
              </div>

              <button
                className={`keyword-save-btn ${isSaved ? "saved" : ""}`}
                onClick={(e) => {
                  e.stopPropagation();
                  onAddFlashcard(word, matchingSentence?.text || null);
                }}
              >
                {isSaved ? (
                  <>
                    <CiBookmarkCheck size={20} /> Remover
                  </>
                ) : (
                  <>
                    <CiBookmarkPlus size={20} /> Salvar
                  </>
                )}
              </button>
            </div>
          );
        })}
      </div> */}
    </div>
  );
}
 